<script setup lang="ts">
import {onMounted, ref, watch} from "vue";
import { useI18n } from "vue-i18n";
import AccountSettings from "@/components/AccountSettings/AccountSettings.vue";
import PaymentMethods from "@/components/PaymentMethods/PaymentMethods.vue";
import PersonalInfo from "@/components/PersonalInfo/PersonalInfo.vue";
import Billing from "@/components/Billing/Billing.vue";
import {useRoute} from "vue-router";

const tab = ref('info');

const route = useRoute();

function selectRoute(query) {
  if (Object.keys(query).length){
    if ("payment" in query) {
      tab.value = 'payment';
    } else if ("billing" in query) {
      tab.value = 'billing';
    }
  } else {
    tab.value = 'info';
  }

}

onMounted(() => {
  selectRoute(route.query);
})

watch(route, (newQuery) => {
  selectRoute(newQuery.query);
})
const { t } = useI18n();
</script>

<template>
    <div class="bg-primary-account flex flex-col justify-between min-h-36">
        <div class="">
            <div class="px-12 responsive-title-3 font-semibold py-8 header">{{ t('myAccount.title') }}</div>
            <ElTabs v-model="tab" @tab-change="(newTab) => { tab = newTab }">
                <ElTabPane :label="t('myAccount.tabs.personalInfo')" name="info" class="px-12 mainPanel">
                    <PersonalInfo />
                </ElTabPane>
                <ElTabPane :label="t('myAccount.tabs.paymentMethods')" name="payment" class="px-12 mainPanel">
                    <PaymentMethods />
                </ElTabPane>
                <ElTabPane :label="t('myAccount.tabs.billing')" name="billing" class="px-12 mainPanel">
                    <Billing />
                </ElTabPane>
                <ElTabPane :label="t('myAccount.tabs.accountSettings')" name="settings" class="px-12 mainPanel">
                    <AccountSettings />
                </ElTabPane>
            </ElTabs>
        </div>
    </div>
</template>

<style scoped>
.border-black {
    border-color: black !important;
}

:deep(.el-tabs__header) {
    padding: 0;
    margin: 0 !important;
}

:deep(.el-tabs__header.is-top) {
    margin: 0 !important;
}

:deep(.el-tabs__nav-wrap:after) {
    background-color: transparent !important;
}

:deep(.el-tabs__content) {
    padding: 0;
    background-color: #FFF;
    width: 100%;
}

:deep(.el-tabs__item:hover),
:deep(.el-tabs__item.is-active) {
    color: black;
    border: black;
}

:deep(.el-tabs__item.is-active) {
    color: black;
    font-weight: 600;
}

:deep(.el-tabs__active-bar) {
    background-color: black;
    height: 3px;
}

:deep(.el-tabs__nav.is-top) {
    padding: 0px 0px 0px 50px;
}

@media (max-width: 768px) {
    .mainPanel {
        padding: 0;
    }

    .header {
        padding-left: 20px;
        font-size: 23px;
    }
}
</style>
